import {
  Box,
  Button,
  Image,
  useMultiStyleConfig,
  useTab,
} from "@chakra-ui/react";
import clsx from "clsx";
import React, { ReactNode } from "react";

import { categoryIcons } from "../../utils/constants";
export interface TabData {
  ioDetailsId?: string;
  edge?: string;
  nodeTitle: string;
  nodeId: string;
  nodeType: string;
  nodeImage: string;
}
interface DataPreviewTabProps {
  children: ReactNode; // Specify string type for children prop
  tabData: TabData;
}

export const DataPreviewTab = React.forwardRef<
  HTMLDivElement,
  DataPreviewTabProps
>((props, ref) => {
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps["aria-selected"];

  const styles = useMultiStyleConfig("Tabs", tabProps);

  return (
    <Button
      // __css={styles.tab}
      sx={{
        all: "unset",
        borderBottomWidth: "2px",
        borderBottomStyle: "solid",
        borderBottomColor: isSelected
          ? categoryIcons[props.tabData.nodeType].theme
          : "transparent",
        "&:hover": {
          bg: "gray.100",
        },
      }}
      {...tabProps}
      className={clsx(
        "!flex !text-sm hover:!bg-gray-100 !cursor-pointer !items-center",
        " !font-medium !gap-2 shrink-0 !mb-[0.5px]"
      )}
    >
      <Image
        className="rounded"
        boxSize="1.5rem"
        p={1}
        bg={categoryIcons[props.tabData.nodeType].theme}
        alt={props.tabData.nodeType + " icon"}
        src={props.tabData.nodeImage}
      />
      <Box
        className="capitalize"
        color={
          isSelected ? categoryIcons[props.tabData.nodeType].theme : "gray.700"
        }
      >
        {tabProps.children}
      </Box>
    </Button>
  );
});
